export enum EctosenseTestUpdateStatus {
    handled = 'handled',
    received = 'received',
    skipped = 'skipped',
}
